'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = require('preact');

var _preactFela = require('preact-fela');

var _actions = require('../../actions');

var _Button = require('../Core/Button');

var _Button2 = _interopRequireDefault(_Button);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ctaButtonStyle = function ctaButtonStyle(_ref) {
  var shadow = _ref.shadow,
      order = _ref.order;
  return {
    boxShadow: shadow ? '0 2px 2px 0 rgba(18, 37, 79, 0.3)' : undefined,
    order: order
  };
};

var wrapperStyle = function wrapperStyle(_ref2) {
  var mobile = _ref2.mobile,
      inside = _ref2.inside;
  return _extends({
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    marginRight: !inside && mobile ? '8px' : undefined
  }, inside ? {
    padding: '16px',
    boxSizing: 'border-box',
    flexDirection: 'column',
    width: '100%',
    '& > *': {
      width: '100%',
      fontSize: '14px',
      margin: '0',
      padding: '14px 0',
      marginTop: '10px'
    }
  } : {}, {
    desktop: {
      '& > *': {
        marginLeft: '8px',
        fontSize: '12px',
        '&:first-child': {
          marginLeft: '16px'
        }
      }
    }
  });
};

var CTAButton = (0, _preactFela.createComponentWithProxy)(ctaButtonStyle, _Button2.default);
var Wrapper = (0, _preactFela.createComponent)(wrapperStyle);

exports.default = function (props) {
  var mobile = props.mobile,
      inside = props.inside,
      login = props.login,
      signUp = props.signUp,
      config = props.config;


  var loginDisabled = login.disabledInNavbar;
  var loginText = login.text;
  var loginAccessibleLabel = login.loginAccessibleLabel;
  var loginPath = login.path;
  var loginEl = typeof login.callback === 'function' ? 'button' : 'a';

  var signUpDisabled = signUp.disabledInNavbar;
  var signUpText = signUp.text;
  var signUpAccessibleLabel = signUp.signUpAccessibleLabel;
  var signUpPath = signUp.path;
  var signUpEl = typeof signUp.callback === 'function' ? 'button' : 'a';

  var color = config.color;
  var inverseColor = config.inverseColor;

  var loginColor = inside ? color : inverseColor;

  var singUpColor = inside ? inverseColor : color;
  var singUpInverseColor = inside ? color : inverseColor;

  var headerGoSignUp = function headerGoSignUp(evt) {
    (0, _actions.goSignUp)(evt, 'navbar');
  };

  return (0, _preact.h)(
    Wrapper,
    { mobile: mobile, inside: inside },
    !loginDisabled && (inside || !mobile) && (0, _preact.h)(
      CTAButton,
      _extends({
        href: loginPath,
        color: loginColor,
        onClick: _actions.goLogin,
        order: inside ? 2 : 1,
        as: loginEl
      }, (0, _utils.getAttrsGtm)(loginText, { clicktype: 'menu' }), {
        'aria-label': loginAccessibleLabel
      }),
      loginText
    ),
    !signUpDisabled && (0, _preact.h)(
      CTAButton,
      _extends({
        href: signUpPath,
        onClick: headerGoSignUp,
        order: inside ? 1 : 2,
        color: singUpColor,
        background: singUpInverseColor,
        shadow: !inside && mobile,
        as: signUpEl
      }, (0, _utils.getAttrsGtm)(signUpText, { clicktype: 'menu' }), {
        'aria-label': signUpAccessibleLabel
      }),
      signUpText
    )
  );
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/components/Header/HeaderProfileCTA.js
// module id = 200
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38